/**
 * React component representing the hero section description.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for the component, including information for the hero section description.
 * @param {Object} props.commonAssets - Common assets for the component.
 * @returns {JSX.Element} React component.
 */

import AddToCartButton from "@/components/common/AddToCartButton";
import { BTN_TYPES } from "@/utils/constants";
import Link from "next/link";

export default function HeroDescription({ data, commonAssets, maticProduct }) {
  return (
    <>
      <div className="">
        <div className="text-white lg:text-lg">
          {data?.heroSectionIntroTitle}
        </div>
        <h1 className="text-[28px] lg:text-[48px] leading-[140%] -tracking-[0.42px] lg:-tracking-[0.72px] text-white mt-4 lg:w-full">
          {data?.heroSectionDescription}
        </h1>
        <Link
          href="/product"
          className="btn-secondary eyebrow-bold mt-4 lg:mt-8 transition-colors inline-flex border-white hover:border-primary"
          title="ORDER MATIC"
        >
          Learn More
        </Link>
      </div>
    </>
  );
}
